// extracted by mini-css-extract-plugin
export default {"mainContainer":"ZQJ2wOg0OzSJQJigxlZA7w==","content":"USy8FLRyLzCuu03vHrgqzA==","icon":"b0l0X7nZyg93sNIf0ycpjQ==","badge":"_9cOmDS+40QKd7fxNrKoGUA=="};